export const COMPANY_NAME = "BATSCCUL ONLINE"
export const COMPANY_NAME_FULL = "BATSCCUL ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "BATSCCUL ONLINE"
export const META_DESCRIPTION = "Welcome to BATSCCUL ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.batsccul.net"
export const ENABLE_OTHER_DEPOSIT = false
